import {filterWordContent, isWordContent} from "./filter/word-filter.js";

(function () {
  'use strict';

  var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

  const retainOptionName = 'paste_retain_word_style_properties';

  const getDataTransferItems = dataTransfer => {
    const items = {};
    if (dataTransfer && dataTransfer.types) {
      for (let i = 0; i < dataTransfer.types.length; i++) {
        const contentType = dataTransfer.types[i];
        try {
          items[contentType] = dataTransfer.getData(contentType);
        } catch (ex) {
          items[contentType] = '';
        }
      }
    }
    return items;
  };

  const openFormattingOptionsDialog = (editor, htmlContent, rtfContent) => {
    editor.windowManager.open({
      title: 'Paste Formatting Options',
      body: {
        type: 'panel',
        items: [
          {
            type: 'htmlpanel',
            html: 'Choose to keep or remove formatting in the pasted content.'
          }
        ]
      },
      buttons: [
        {
          type: 'submit',
          text: 'Keep Formatting',
          buttonType: 'primary',
        },
        {
          type: 'cancel',
          text: 'Remove Formatting',
        }
      ],
      onSubmit: (api) => {
        api.close();
        handleFormattingDecision(editor, htmlContent, rtfContent);
      },
      onCancel: (api) => {
        api.close();
        handleFormattingDecision(editor, htmlContent, rtfContent, false);
      }
    });
  };

  const handleFormattingDecision = (editor, htmlContent, rtfContent, keepFormatting = true) => {
    if (!keepFormatting) {
      var option = editor.options.get(retainOptionName);
      editor.options.unset(retainOptionName);
      editor.insertContent(filterWordContent(editor, htmlContent, rtfContent), {paste: true});
      editor.options.set(retainOptionName, option);
    } else {
      editor.insertContent(filterWordContent(editor, htmlContent, rtfContent), {paste: true});
    }
  };

  const handlePasteEvent = (editor, e) => {
    const content = getDataTransferItems(e.clipboardData);
    const htmlContent = content["text/html"] || '';
    const rtfContent = content["text/rtf"] || '';

    if (isWordContent(htmlContent)) {
      openFormattingOptionsDialog(editor, htmlContent, rtfContent);
      e.preventDefault();
    }
  };

  const registerOptions = editor => {
    const registerOption = editor.options.register;
    registerOption("paste_convert_word_fake_lists", {processor: "boolean", default: true});
    registerOption(retainOptionName, {processor: "string"});
  };

  const setupPasteListener = editor => {
    editor.on('paste', (e) => {
      handlePasteEvent(editor, e);
    });
  };

  const initializePlugin = () => {
    global.add('paste', function (editor) {
      registerOptions(editor);
      setupPasteListener(editor);
      return {};
    });
  };

  initializePlugin();
}());
